export const getCopyMachineCoords = (
  machine: { x: number; y: number },
  map: {
    width: number;
    height: number;
    ratio: number;
  }
): { x: number; y: number } => {
  const maxX = (map.width ?? 0) / map.ratio;
  const maxY = (map.height ?? 0) / map.ratio;

  return {
    x: maxX < machine.x + 50 ? machine.x - 50 : machine.x + 50,
    y: maxY < machine.y + 50 ? machine.y - 50 : machine.y + 50,
  };
};
